const NewsSearch = () => {
    if ( document.getElementById('news_search_select2') ) {
      (function($) {

        var Defaults = $.fn.select2.amd.require('select2/defaults');
      
        $.extend(Defaults.defaults, {
          dropdownPosition: 'auto'
        });
      
        var AttachBody = $.fn.select2.amd.require('select2/dropdown/attachBody');
      
        var _positionDropdown = AttachBody.prototype._positionDropdown;
      
        AttachBody.prototype._positionDropdown = function() {
      
          var $window = $(window);
      
          var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
          var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');
      
          var newDirection = null;
      
          var offset = this.$container.offset();
      
          offset.bottom = offset.top + this.$container.outerHeight(false);
      
          var container = {
              height: this.$container.outerHeight(false)
          };
      
          container.top = offset.top;
          container.bottom = offset.top + container.height;
      
          var dropdown = {
            height: this.$dropdown.outerHeight(false)
          };
      
          var viewport = {
            top: $window.scrollTop(),
            bottom: $window.scrollTop() + $window.height()
          };
      
          var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
          var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);
      
          var css = {
            left: offset.left,
            top: container.bottom
          };
      
          // Determine what the parent element is to use for calciulating the offset
          var $offsetParent = this.$dropdownParent;
      
          // For statically positoned elements, we need to get the element
          // that is determining the offset
          if ($offsetParent.css('position') === 'static') {
            $offsetParent = $offsetParent.offsetParent();
          }
      
          var parentOffset = $offsetParent.offset();
      
          css.top -= parentOffset.top
          css.left -= parentOffset.left;
      
          var dropdownPositionOption = this.options.get('dropdownPosition');
      
          if (dropdownPositionOption === 'above' || dropdownPositionOption === 'below') {
            newDirection = dropdownPositionOption;
          } else {
      
            if (!isCurrentlyAbove && !isCurrentlyBelow) {
              newDirection = 'below';
            }
      
            if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
              newDirection = 'above';
            } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
              newDirection = 'below';
            }
      
          }
      
          if (newDirection == 'above' ||
          (isCurrentlyAbove && newDirection !== 'below')) {
              css.top = container.top - parentOffset.top - dropdown.height;
          }
      
          if (newDirection != null) {
            this.$dropdown
              .removeClass('select2-dropdown--below select2-dropdown--above')
              .addClass('select2-dropdown--' + newDirection);
            this.$container
              .removeClass('select2-container--below select2-container--above')
              .addClass('select2-container--' + newDirection);
          }
      
          this.$dropdownContainer.css(css);
      
        };
      
    })(window.jQuery);

        jQuery( document ).ready(function($) {

            $(document).on('select2:open', () => {
                document.querySelector('.select2-search__field').focus();
            });
    
            $('#news_search_select2').select2({
                theme: "news-search",
                dropdownParent: $('#news_search_select2').parent(),
                dropdownPosition: 'below',
                templateResult: formatMe,
                placeholder: 'Es. Casa di Riposo e Centro Alzheimer Saccardo',
                allowClear: true,
                language: {
                    noResults: function () {
                      return "Nessun risultato trovato";
                    }
                }
                  
            }).on('change', (e) => {
                if ( e.target.value != '' ) {
                    let news_url = document.getElementById('news_url');
                    
                    if ( news_url ) {
                        let newurl = new URL(news_url.value);
                        if ( e.target.value == '*' ) {
                            window.location = newurl;
                            return false;
                        }
                        newurl.searchParams.set('structure', e.target.value);
                        window.location = newurl;
                        return false;
                    }
                    //location.reload();
                    //return false;
                }
            });

        });
        function formatMe(result) {
            if (!result.id) {
                return result.text;
            }
        
            var query = jQuery('.select2-search__field').val();
            var str = result.text;
        
            var regex = new RegExp(query, 'i');
            var indexQuery = (str.toLowerCase()).indexOf(query.toLowerCase());
        
            var highlightText = str.substring(indexQuery, indexQuery + query.length);
            var newStr = str.replace(regex, '<span style="font-weight:bold">' + highlightText + '</span>')
        
            return jQuery('<span>' + newStr + '</span>');
        }
    }
}

export default NewsSearch;